// extracted by mini-css-extract-plugin
export default {"nav":"ToolsNav_nav__VWM9s"};